/**
 * Reusable "How It Works" steps data
 * Used in Login page and HowItWorksModal
 */
export const howItWorksSteps = [
  {
    number: 1,
    title: {
      eng: 'Upload Files',
      esp: 'Sube tus archivos'
    },
    description: {
      eng: 'Upload your PDF documents by dragging or selecting them',
      esp: 'Sube tus documentos PDF arrastrándolos o seleccionándolos'
    },
    isOptional: false
  },
  {
    number: 2,
    title: {
      eng: 'Specify DUAs and Partidas',
      esp: 'Especifica DUAs y Partidas'
    },
    description: {
      eng: 'Specify the number of DUAs and Partidas needed',
      esp: 'Indica el número de DUAs y Partidas necesarias'
    },
    isOptional: true
  },
  {
    number: 3,
    title: {
      eng: 'Add Additional Context',
      esp: 'Añade contexto adicional'
    },
    description: {
      eng: 'Provide additional information to enhance AI accuracy',
      esp: 'Proporciona información adicional para mejorar la precisión de la IA'
    },
    isOptional: true
  },
  {
    number: 4,
    title: {
      eng: 'Process and Review',
      esp: 'Procesa y revisa'
    },
    description: {
      eng: 'Confirm and process. Review extracted data and fix any errors',
      esp: 'Confirma y procesa. Revisa los datos extraídos y corrige errores'
    },
    isOptional: false
  },
  {
    number: 5,
    title: {
      eng: 'Complete Required Fields',
      esp: 'Completa campos requeridos'
    },
    description: {
      eng: 'Use the Errors tab to find and complete missing required fields',
      esp: 'Usa la pestaña de Errores para encontrar y completar campos faltantes'
    },
    isOptional: false
  },
  {
    number: 6,
    title: {
      eng: 'Work with Declarations',
      esp: 'Trabaja con declaraciones'
    },
    description: {
      eng: 'Review and edit items, documents, and packages as needed',
      esp: 'Revisa y edita items, documentos y paquetes según sea necesario'
    },
    isOptional: false
  },
  {
    number: 7,
    title: {
      eng: 'Select Sender and Receiver',
      esp: 'Selecciona remitente y destinatario'
    },
    description: {
      eng: 'Select sender, receiver, and agent (optional) in the Review section',
      esp: 'Selecciona el remitente, destinatario y agente (opcional) en la sección de Revisión'
    },
    isOptional: false
  },
  {
    number: 8,
    title: {
      eng: 'Review and Generate',
      esp: 'Revisa y genera'
    },
    description: {
      eng: 'Review the final JSON and generate your Taric DUAS declaration',
      esp: 'Revisa el JSON final y genera tu declaración Taric DUAS'
    },
    isOptional: false
  }
];

